import React, { FC, useContext } from "react";
import { ThemeContext } from "styled-components";
import { SearchIconSvg } from "../../../icons/SearchIconSvg";
import { redirectKeyPressToClick } from "../../../../helpers/interactionHandlers";
import { colors } from "../../../../styles/variables";
import { StyledIconAndText, StyledLabel } from "./index.styled";

export interface SearchBarProps {
  onSearchClicked?: React.MouseEventHandler;
  placeholderText: string;
  showSearchBar: boolean;
}

export interface SearchProps {
  isLoggedIn: boolean;
  onSearchClicked?: React.MouseEventHandler;
}

export const Search: FC<SearchProps> = ({
  isLoggedIn,
  onSearchClicked,
}: SearchProps) => {
  const theme = useContext(ThemeContext);
  if (!isLoggedIn) return null;

  return (
    <StyledIconAndText
      tabIndex={0}
      onKeyDown={redirectKeyPressToClick}
      onClick={onSearchClicked}
    >
      <SearchIconSvg
        width="28"
        height="28"
        color={theme.header?.shop?.navLinkColor || colors.white}
      />
      <StyledLabel>Search</StyledLabel>
    </StyledIconAndText>
  );
};
